<script>
    import GeneralLayout from "../../common/GeneralLayout.svelte";
    import HeaderBar from "../../components/header/HeaderBar.svelte";
    import {_} from "svelte-i18n";
    import {getSocials} from "./social.datasource";
    import LoadingSquare from "../../common/LoadingSquare.svelte";
    import {onMount} from "svelte";

    let socials = null;
    let loading = true;
    let error = null;

    onMount(async () => {
        try {
            socials = await getSocials();
        } catch (e) {
            error = e;
        }
        loading = false;
    });

</script>

<GeneralLayout>
    <div slot="headerBar">
        <HeaderBar hideSeperator/>
    </div>
    <div style="padding-left: 16px; padding-right: 16px" slot="firstSegment">
        <div class="headline-l title">#FONDATIONBEYELER</div>
        <div style="margin-top: 40px" class="text-l">
            {$_("explore_description")}
        </div>
        <a
                href="https://www.instagram.com/fondationbeyeler/"
                style="margin-top: 24px; display: block; cursor: pointer"
                class="headline-xs">INSTAGRAM</a
        >
    </div>
    <div slot="secondSegment">
        <div style="padding-left: 16px; padding-right: 16px">
            <div
                    style="margin-top: 40px;margin-bottom: 40px"
                    class="divider-h display-small"
            />
            <div class="social-grid">
                {#if (loading)}
                    <LoadingSquare/>
                {:else if (error)}
                    <div class="error">
                        <span class="text-l" style="font-size: 24px;">
                            {$_("entity_load_error")}
                        </span>
                    </div>
                {:else if (socials)}
                    {#each socials as social}
                        <a href="https://www.instagram.com/fondationbeyeler/">
                            <img
                                    class="imageBlur"
                                    on:error={() => {socials = socials.filter(s => s.id != social.id)}}
                                    style="width: 100%; height: 100%; object-fit: cover; aspect-ratio: 1;"
                                    src={social.display_url}
                            />
                        </a>
                    {/each}
                {/if}
            </div>
        </div>
    </div>
</GeneralLayout>

<style>
    .social-grid {
        display: grid;
        grid-template-columns: fit-content(300px) fit-content(300px) fit-content(
                300px
            );
        grid-gap: 8px;
        justify-content: center;
    }


    @media (min-width: 1440px) {
        .display-small {
            display: none;
        }

        .social-grid {
            grid-gap: 32px;
        }
    }

    .headline-l {
        font-size: 60px;
    }
</style>
